import { render } from "./LoadingScreen.vue?vue&type=template&id=16edff75&scoped=true"
import script from "./LoadingScreen.vue?vue&type=script&lang=js"
export * from "./LoadingScreen.vue?vue&type=script&lang=js"

import "./LoadingScreen.vue?vue&type=style&index=0&id=16edff75&scoped=true&lang=css"

import exportComponent from "/app/code_base/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16edff75"]])

export default __exports__